import { render, staticRenderFns } from "./secondarydealerfilestable.vue?vue&type=template&id=61d6ae0e&scoped=true&"
import script from "./secondarydealerfilestable.vue?vue&type=script&lang=js&"
export * from "./secondarydealerfilestable.vue?vue&type=script&lang=js&"
import style0 from "./secondarydealerfilestable.vue?vue&type=style&index=0&id=61d6ae0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6ae0e",
  null
  
)

export default component.exports